import { render, staticRenderFns } from "./pha.vue?vue&type=template&id=6f2ff80c&"
import script from "./pha.vue?vue&type=script&lang=js&"
export * from "./pha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports